import {useEffect} from "react";

type ICallback = () => void;

const useMount = (callback: ICallback): void => {
    useEffect(callback, [])
}

export default useMount;